import { useCallback } from 'react';
import qs from 'query-string';
import { getMeetGoConditions } from '@encarpkg/api';
import { loggingException } from 'app/libs/sentry';
import useCars from 'app/hook/cars/useCars';
import useService from 'app/hook/cars/useService';
import useAuth from 'app/hook/common/useAuth';
import usePixel from 'app/hook/common/usePixel';
import { windowPopupWithApp } from 'app/libs/location';

const buyHost = process.env.REACT_APP_ENCAR_FEM_BUY;

function useApplyCheck() {
	const { sessionCheckInfo } = useAuth();
	const { base } = useCars();

	const { isService } = useService();

	const { excuteKakaoPixel, excuteFbPixel } = usePixel();

	const { homeServiceDummy } = isService;

	const getCurrentUserLoginStatus = useCallback(async () => {
		try {
			await sessionCheckInfo();
			return true;
		} catch (e) {
			return false;
		}
	}, [sessionCheckInfo]);

	const checkMeetgoCarHsCondition = useCallback(async () => {
		try {
			const { data } = await getMeetGoConditions(base.vehicleId);
			return data.apply;
		} catch (e) {
			console.log(e);
			loggingException(e);
			return false;
		}
	}, [base.vehicleId]);

	const applyOriginHomeservice = async ({ click_type, inflow } = {}) => {
		const from_click = click_type ?? (homeServiceDummy ? 'hsad_main' : 'cardetail_seller_info');

		let url;
		const baseParam = {
			carId: base.vehicleId,
			from_click,
			...(inflow && { inflow }),
		};
		if (homeServiceDummy) {
			excuteKakaoPixel('hs_apply_home');
			excuteFbPixel('hs_apply_home');

			const queryString = qs.stringify({
				...baseParam,
				'WT.hit': 'hs_ad',
			});

			url = `${buyHost}/home-service/apply-intro?${queryString}`;
		} else {
			excuteKakaoPixel('hs_apply_deal');
			excuteFbPixel('hs_apply_deal');

			const queryString = qs.stringify({
				...baseParam,
				'WT.hit': 'cardetail_seller_info',
			});

			url = `${buyHost}/home-service/apply-intro?${queryString}`;
		}
		setTimeout(() => windowPopupWithApp('_blank', url, 500, 920, url), 100);
	};

	return {
		getCurrentUserLoginStatus,
		applyOriginHomeservice,
		checkMeetgoCarHsCondition,
	};
}

export default useApplyCheck;
